/** import package [start] */
import { useState, useImperativeHandle, forwardRef } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Button } from '@zeeve-platform/button-component';
/** import package [end] */

export interface IFRef {
    isValid: () => boolean;
    getTotal: () => number;
    getQuantity: () => number;
}

/** type declaration for the Nodes component props */
export interface NodesProps {
    price: number;
    onSubmit: (totalCost: number) => void;
    count: number;
    setCount: React.Dispatch<React.SetStateAction<number>>;
}

/**
 * Nodes component
 * @returns JSX.Element
 */
const Nodes = forwardRef<IFRef, NodesProps>(({ onSubmit, price, count, setCount }, ref): JSX.Element => {
    //misc
    const [componentError, setComponentError] = useState<string | null>(null);

    //component dependent states
    const [total, setTotal] = useState<number>(count * price);

    //exposed states and functions
    useImperativeHandle(ref, () => {
        return {
            isValid: () => {
                return !componentError;
            },
            getTotal: () => total,
            getQuantity: () => count,
        };
    });

    const handleCount = (e: { target: { value: string } }) => {
        let count = parseInt(e.target.value, 10);
        if (count > 0 && count <= 100) {
            setComponentError(null);
        } else if (count > 100) {
            count = 100;
            setComponentError('Number of nodes cannot be more than 100.');
        } else {
            setComponentError('Number of nodes cannot be less than 1.');
        }
        
        setCount(count);
        setTotal(count * price);
        
    };

    return (
        <>
            <div className='mb-4 subcriptioninput'>
                <label htmlFor='monthly-cost' className='form-label fw-bold mb-2' style={{ fontWeight: 700 }}>
                    Per Node Monthly Cost (USD)
                </label>
                <Inputbox type='text' className='form-control' id='monthly-cost' value={`$ ${price}`} disabled />
            </div>
            <div className='mb-4 subcriptioninput'>
                <label htmlFor='node-count' className='form-label fw-bold mb-2' style={{ fontWeight: 700 }}>
                    Enter Number of Nodes
                </label>
                <div className='input-group'>
                    <Inputbox
                        type='number'
                        className='form-control rounded-start'
                        style={{ borderRadius: '8px 0px 0px 8px !important' }}
                        value={count}
                        min={0}
                        max={100}
                        id='node-count'
                        onChange={handleCount}
                    />
                    <span className='input-group-text cursor' style={{ borderRadius: '0px 8px 8px 0px !important' }}>
                        Nodes
                    </span>
                </div>
            </div>
            <div className='mb-4 subcriptioninput'>
                <label htmlFor='total-cost' className='form-label fw-bold mb-2' style={{ fontWeight: 700 }}>
                    Total Monthly Cost (USD)
                </label>
                <input type='text' className='form-control' id='total-cost' value={`$ ${count * price}`} disabled />
            </div>
            {componentError && (
                <div className='alert-danger mt-4 rounded text-center'>
                    <p className='text-danger  py-2'>{componentError}</p>
                </div>
            )}
            <div className='row mt-3 mb-5'>
                <div className='mx-1 col-5'>
                    <Button
                        type='button'
                        disabled={componentError ? true : false}
                        className='btn btn-success rounded'
                        onClick={onSubmit}
                    >
                        Subscribe
                    </Button>
                </div>
            </div>
        </>
    );
});

Nodes.displayName = 'Nodes';

export default Nodes;
